import Swal from 'sweetalert2'

const fireSuccessSwal = (message, redirectUrl = "") => {
	Swal.fire({
		position: 'center',
		icon: 'success',
		title: message,
		width: '26em',
		customClass: {
			title: 'swal2-title gc-alert-text',
			confirmButton: 'the-btn third-btn',
		}
	}).then(function() {
		if (redirectUrl !== "") {
			let overlayHtmlString = document.getElementById("loading-overlay").innerHTML;
			let loadOverlay = document.createRange().createContextualFragment(overlayHtmlString);
			document.body.appendChild(loadOverlay);
			window.location = redirectUrl;
		}
	});
}

export default fireSuccessSwal;
